import endpoints from "../data/endpoints";
import { LocalizedContent, LocalizedNonce } from "../types/types";

declare global {
	interface Window {
		midtownMembershipsVerify: LocalizedNonce;
		midtownMembershipsContent: LocalizedContent;
	}
}

type EndpointKeys = keyof typeof endpoints;

const apiRequest = async (action: EndpointKeys, requestBody: any[] = []) => {
	const endpoint = endpoints[action];
	try {
		const headers: Record<string, string> = {
			"Content-Type": "application/json",
			...(window?.midtownMembershipsVerify?.nonce_verification_enabled && {
				"X-WP-Nonce": window?.midtownMembershipsVerify?.nonce || "",
			}),
		};

		const response = await fetch(endpoint.url, {
			method: endpoint.requestMethod,
			headers,
			credentials: "same-origin",
			...(endpoint.requestMethod === "POST" && {
				body: formatRequestBody(requestBody),
			}),
		});

		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const result = await response.json();

		return result;
	} catch (error) {
		const message =
			error instanceof Error ? error.message : "Something went wrong";
		throw new Error(message);
	}
};

// Formats the key value pairs in the request body.
const formatRequestBody = (data: { [key: string]: any }[]) => {
	const flattened = data.reduce((acc, obj) => {
		const [key, value] = Object.entries(obj)[0];
		acc[key] = value;
		return acc;
	}, {});

	return JSON.stringify(flattened);
};

export default apiRequest;
